import GENESIS_Booleans from '@toolproof-core/genesis/_data/timestamped-resources/booleans';
import GENESIS_Naturals from '@toolproof-core/genesis/_data/timestamped-resources/naturals';
import GENESIS_ResourceTypes from '@toolproof-core/genesis/_data/timestamped-resources/resource-types';
import GENESIS_Tools from '@toolproof-core/genesis/_data/timestamped-resources/tools';

import { CONSTANTS } from '@toolproof-core/lib/_data/lookups';

import type { ResourceTypeRequirement } from '@/workflow/_contract/config';

export const TYPE_Tool = CONSTANTS.Handles.ResourceTypes.TYPE_Tool;
export const TYPE_ResourceType = CONSTANTS.Handles.ResourceTypes.TYPE_ResourceType;
export const TYPE_Boolean = CONSTANTS.Handles.ResourceTypes.TYPE_Boolean;
export const TYPE_Natural = CONSTANTS.Handles.ResourceTypes.TYPE_Natural;

export const RESOURCE_TYPE_REQUIREMENTS = [
    TYPE_Tool,
    TYPE_ResourceType,
    TYPE_Boolean,
    TYPE_Natural,
    CONSTANTS.Handles.ResourceTypes.TYPE_WorkflowTrace,
] as const satisfies readonly ResourceTypeRequirement[];

export const PRESET_TIMESTAMPED_RESOURCES_BY_TYPE = {
    [TYPE_Tool]: GENESIS_Tools,
    [TYPE_ResourceType]: GENESIS_ResourceTypes,
    [TYPE_Boolean]: GENESIS_Booleans,
    [TYPE_Natural]: GENESIS_Naturals,
} as const;
